import React from 'react'
import { API_URL } from '../Constants'
import { SectionBase, DifficultyBadge, Time, NextQuestion} from '../Shared/SectionBase'
import { Link } from 'react-router-dom'
import Menu from '../Shared/Menu';
import TargetSelect from './TargetSelect';
import TargetRadio from '../Shared/TargetRadio';
import { isNullOrUndefinedOrWhitespace, getAlts } from '../Utils';
export default class InteractiveReading extends SectionBase  {
  
  constructor(props) {
    super(props)
    this.checkSelection = this.checkSelection.bind(this)
    this.getQuestion = this.getQuestion.bind(this)
    this.nextQuestion = this.nextQuestion.bind(this);
    this.onDifficultyChange = this.onDifficultyChange.bind(this);
    this.retry = this.retry.bind(this);
    this.setAnswer = this.setAnswer.bind(this)
    this.submit = this.submit.bind(this)
  }

    TEST_TIME_SECONDS = 120
    DEFAILT_QUESTIONS = {'selecttitle':'Select the best title for the passage','fillgap':'Select the best sentence to fill in the gap'}

    state = {
        difficulty:1
    }

    checkSelection(){
      const {answer, question_type} = this.state;
      if (question_type === 'selecttext'){
      const selection = (window.getSelection()).toString().trim();
        console.log(selection);
        console.log(this.state.answer);
        if (selection!== answer){
          this.setAnswer(0,selection) 
        }
      }
    }
    
    async nextQuestion(){
        console.log('nextQ');
        const secondsLeft = this.TEST_TIME_SECONDS;
        const step = 1;
        const answer = undefined;
        const {difficulty} = this.state;
        const { token } = this.props;
    
          const res = await fetch(`${API_URL}/interactivereading/createquestion/${difficulty}`,
            { headers: { Authorization: `Token ${token}` } });
          try {
            const result = await res.json();
            const reading_dump = result[0].text;
            const interactivereading_id = result[0].id;
            const {question_data} = result[0];
            const {question_type, correct_answer} = question_data;
            const question = this.getQuestion(question_type, result[0].question)
            const parts = this.prepareParts(question_data.parts, true);
            
            console.log(parts);
            console.log(secondsLeft);
            this.setState({ interactivereading_id, reading_dump, question,parts,question_type, correct_answer, secondsLeft, step,answer },this.restartTimer);
            
          } catch (e) {
            console.log(e);
            console.log(res);
          }
      }

    
    getQuestion(question_type, question){
      if (question!== undefined && question!==null && question.length>0){
        console.log(question);
        return question;
      }
      console.log(question_type);
      return this.DEFAILT_QUESTIONS[question_type];
    }

    onTimeIsUp(){
        this.setState({step:2})
    }

  

  onDifficultyChange(e){
    this.setState({difficulty:e.target.value}, this.nextQuestion);
    
  }


  prepareParts(parts){
    let firstTargetInd = null;
    for (var i=0;i<parts.length;i++){
      const p = parts[i];
      if (p.is_target){
        if (p.alts !== undefined){
          p.preparedAlts = getAlts(p);
        }
        if (firstTargetInd === null){
          firstTargetInd = i;
        }
        
      }
    }

    return parts;
  }
  
  render() {
        const { token } = this.props;
        
       
        
        const { question, question_type, parts, secondsLeft, step, profile, difficulty, answer, correct_answer } = this.state;
        
        const showCorrect = step>1;

        const getShowCorrectClass = ()=>{
          return showCorrect?(answer===correct_answer?'alert bg-success text-white':'alert alert-danger text-danger'):'bg-light';
        }

       


        return (
          <>
            {token!==null && parts && <div className={`interactivereading interactivereading-step${step}`}>
              <Menu token={token}  profile={profile}onDifficultyChange={this.onDifficultyChange}></Menu>
              <Time seconds={secondsLeft}></Time>
              <DifficultyBadge difficulty={difficulty}></DifficultyBadge>
              <div onMouseMove={this.checkSelection}  className='px-5' >
                <h1 className='text-center'>{question}</h1>
                <div className='parts my-5'>{ parts.map((p, partInd) => {
                  p.elementKey = `part-${partInd}`;
                  if (p.is_blank){
                    return <>
                    <div className='mt-2'></div>
                    {question_type  === 'selecttext' && <div style={{maxWidth:'400px'}} className='m-auto text-center bg-light rounded-top mb-0 mt-4'>Click and drag the text in the paragraph above to highlight the answer</div>}
                    <div className={`p-2 mb-2 border rounded ${getShowCorrectClass()}`}>{(isNullOrUndefinedOrWhitespace(answer))?<span style={{opacity:0}}>dummy</span>:answer}</div>
                  </>
                  }
                  else if (p.is_target){
                   
                    if (p.alts !== undefined){
                        if (question_type==='selectoption'){
                          return <TargetSelect options={p.preparedAlts} showCorrect={showCorrect} disabled={step>1} key={p.elementKey} correctAnswer={p.text} answer={p.answer} onChange={(e)=>{this.setAnswer(partInd,e.target.value)}}></TargetSelect>
                        }else{
                          return <TargetRadio options={p.preparedAlts} showCorrect={showCorrect} disabled={step>1} key={p.elementKey} correctAnswer={correct_answer} answer={answer} onChange={(e)=>{this.setAnswer(partInd,e.target.value)}}></TargetRadio>
                      
                        }
                        
                    }else{
                        //select text question type
                        return <div  key={p.elementKey} className={`text-muted d-inline ${showCorrect?'fw-bold bg-warning btn-correct-word px-1 btn':''}`}>{p.text}</div>
                    }
                    }else{
                    return <div  key={p.elementKey} className='text-muted d-inline'>{p.text}</div>
                  }
                })}</div>
                
               
                {step >= 2 && question_type==='selectoption' && <>
                  <div className='result mb-2'>
                    <div className='custom-box-1 my-5 bg-light m-auto p-3'>
                      <h4>Correct Answer</h4>
                      { parts.map((p, partInd) => {
                    p.elementKey = `part-correct-${partInd}`;
                    if (p.is_target){
                      return <div key={p.elementKey} className='d-inline fw-bold bg-warning btn-correct-word btn'>{p.text}</div>
                    }else{
                      return <div  key={p.elementKey} className='d-inline'>{p.text}</div>
                    }
                  })}</div>
                </div>
                  
                </>
                }
    
              
    
                <div className='buttons d-flex justify-content-between'>
                  <button type="button" className={`btn btn-dark rounded-pill`} onClick={this.retry}>RETRY</button>
    
                  {step === 1 && <button type="button" className={`btn btn-dark rounded-pill`} onClick={this.submit}>SUBMIT</button>
                  }
                </div>
                <NextQuestion nextQuestion={this.nextQuestion}></NextQuestion>
                {false && <div>{JSON.stringify(this.state)}</div>}
              </div>
            
            </div>}
            
            {token === null && <div className='p-5'>Please <Link to="/home/">login</Link> and refresh this page</div>}

          </>
    
        )
      }

  
  retry() {
    const parts = this.prepareParts([...this.state.parts],true );
    this.setState({ parts, step: 1, answer:undefined, secondsLeft: this.TEST_TIME_SECONDS });
    this.restartTimer();
  }

  setAnswer(partInd, value){
    const {question_type} = this.state;
    if (question_type!=='selectoption'){
      this.setState({answer:value})
    }else{
      const parts = [...this.state.parts];
      parts[partInd].answer = value;
      this.setState({parts});
    }
  }
  
  async submit(){
    const {parts,reading_dump, interactivereading_id} = this.state;
    /* TODO words should be submitted for selectoption.
    TODO think about other question types submissions
    let submittedWords = []
    for (var i=0;i<parts.length;i++){
      const p = parts[i];
      if (p.is_target){
        submittedWords.push({
          word:p.word,
          answer:p.answer,
          part_ind:i,
          interactivereading:interactivereading_id,
          reading_dump:reading_dump
        })
      }
    }
   
    console.log(submittedWords);
    const res = await fetch(`${API_URL}/interactivereading/interactivereadingsubmittedanswer`, {
      method: 'POST',
      body: JSON.stringify(submittedWords),
      headers: { Authorization: `Token ${this.props.token}`,"Content-Type": "application/json" } 
    });
    const data = await res.json();

    console.log(data);
    */
    this.stopTimer();
    this.setState({ step: 2 });
    
  }

  setWordFocus(i){
      
      const {parts} = this.state;
      for (var j=0;j<parts.length;j++){
        parts[j].is_focus = j===i?true:false;
      }
      this.setState({parts});
  }
}
